export default __webpack_public_path__ + "static/media/Tunic of the Shivering Stars.72913d35.jpg";